/* angular:styles/component:css;ffd3cccde10268401847f0364b737a3ec59d852d2d9bb1f41edeae4fe2203a09;/opt/build/repo/ui/src/app/shared/components/edge/offline/offline.component.ts */
ion-item > ion-label > h3 {
  font-weight: bolder;
}
/*# sourceMappingURL=offline.component.css.map */
